import { render, staticRenderFns } from "./SimpleMenu.vue?vue&type=template&id=65d7b757"
import script from "./SimpleMenu.vue?vue&type=script&lang=js"
export * from "./SimpleMenu.vue?vue&type=script&lang=js"
import style0 from "./SimpleMenu.vue?vue&type=style&index=0&id=65d7b757&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports